module.exports = __webpack_public_path__ + "media/images/workplace/banners/uhrs_qualify_banner_variant6_image-ff21d609c882696e8d74cb3b4700bb70.jpg";